module.exports = {
    completedColor: "#8084c3"
};